import * as React from 'react';
import { SelectionCard } from '../../../../shared/SelectionCard';

export interface IPasswordProviderCardProps {
  onClick: () => void;
  selected: boolean;
  animationDelay?: number;
}

export const PasswordProviderCard = React.memo(
  (props: IPasswordProviderCardProps): React.ReactElement => {
    return (
      <SelectionCard
        selected={props.selected}
        onClick={props.onClick}
        icon='lock'
        title='Email and Password'
        description='Sign in with your email and password'
        animationDelay={props.animationDelay}
      />
    );
  },
  (
    prevProps: Readonly<IPasswordProviderCardProps>,
    nextProps: Readonly<IPasswordProviderCardProps>
  ): boolean => {
    return (
      prevProps.selected === nextProps.selected &&
      prevProps.onClick === nextProps.onClick &&
      prevProps.animationDelay === nextProps.animationDelay
    );
  }
);

PasswordProviderCard.displayName = 'PasswordProviderCard';
